import { __decorate } from "tslib";
import { DestroyRef } from '@angular/core';
import { CrudServiceFactory, provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import { FeatureFunctionalityModelTableColumn } from '@core/shared/model';
import { VirtualPropertyHelper } from '@core/shared/virtual-properties';
import { MandatoryCourseGroupItem } from '@mpf/courses/shared';
import { map, take } from 'rxjs';
import * as i0 from "@angular/core";
let MpfCoursesFrontendManagementFeature = /*#__PURE__*/(() => {
  let MpfCoursesFrontendManagementFeature = class MpfCoursesFrontendManagementFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@mpf/courses/frontend-management","featureId":"mpf-courses"};
    }
    getFeatureFunctionality(functionality) {
      const simpleAbilityCheck = {
        allow: [[UserRole.MANAGER, "Feature.mpf-courses.Manage"]]
      };
      functionality.defineMenuItems({
        managementToolbar: {
          basePath: 'management/courses',
          items: [{
            label: 'Teamstatus & Prüfungen',
            routerLink: '',
            icon: 'chalkboard-teacher',
            simpleAbilityCheck,
            priority: 15,
            declareGroup: 'management-courses',
            items: [{
              priority: 10,
              label: 'Teamstatus',
              icon: 'chart-bar',
              simpleAbilityCheck,
              routerLink: '',
              routerLinkActiveOptions: {
                exact: true
              }
            }, {
              priority: 10,
              label: 'Pflichtkurs-Gruppen',
              icon: 'list',
              simpleAbilityCheck,
              routerLink: 'mandatory-courses-presets'
            }, {
              priority: 10,
              label: 'Prüfungszulassungen',
              icon: 'graduation-cap',
              simpleAbilityCheck,
              routerLink: 'admissions'
            }]
          }]
        }
      });
      functionality.defineRouterLinkRedirects([{
        matcher: '/management',
        redirect: (path, tree, resolve) => resolve('management-courses'),
        type: 'Redirect'
      }]);
      functionality.defineModelColumns([new FeatureFunctionalityModelTableColumn('UserItem', ['crud'], injector => {
        const MCGService = injector.get(CrudServiceFactory).useDestroyRef(injector.get(DestroyRef)).createCrudService(MandatoryCourseGroupItem);
        MCGService.useCrudEndpoint('manager');
        return MCGService.readMany().pipe(take(1), map(mandatoryCourseGroups => {
          return {
            field: 'mandatoryCourseGroup',
            header: 'Gruppe',
            width: '',
            sortable: true,
            render: (user, dep) => {
              const mcgId = VirtualPropertyHelper.get(user, 'mandatoryCourseGroup');
              if (mcgId) {
                const matchedMcg = mandatoryCourseGroups.find(mcg => mcg.id === mcgId);
                if (!matchedMcg) {
                  console.error('MCG with ID ' + mcgId + ' is unknown!');
                  return '???';
                }
                return matchedMcg.name;
              }
              return '-';
            },
            clientSorting: (a, b, dep) => {
              const mcgIdA = VirtualPropertyHelper.get(a, 'mandatoryCourseGroup');
              const mcgIdB = VirtualPropertyHelper.get(b, 'mandatoryCourseGroup');
              if (!mcgIdA && !mcgIdB) return 0;
              if (!mcgIdA) return -1;
              if (!mcgIdB) return 1;
              if (mcgIdA === mcgIdB) return 0;
              const mcgA = mandatoryCourseGroups.find(mcg => mcg.id === mcgIdA);
              const mcgB = mandatoryCourseGroups.find(mcg => mcg.id === mcgIdB);
              if (!mcgA) return -1;
              if (!mcgB) return 1;
              return mcgA.name < mcgB.name ? -1 : 1;
            }
          };
        }));
      })]);
      functionality.defineWidgets([{
        type: 'Dashboard',
        id: 'CoursesMcgShortcutsWidget',
        priority: 15,
        name: 'Pflichtkursgruppen',
        defaultVisibility: 'show',
        dashboardIds: ['management'],
        simpleAbilityCheck: ['MANAGER'],
        load: () => import('./widgets/mcg-shortcuts.widget').then(m => m.CoursesMcgShortcutsWidget),
        config: {}
      }, {
        type: 'Dashboard',
        id: 'CoursesStatisticsShortcutsWidget',
        priority: 15,
        name: 'Pflichtkursgruppen',
        defaultVisibility: 'show',
        dashboardIds: ['management'],
        simpleAbilityCheck: ['MANAGER'],
        load: () => import('./widgets/statistics-shortcuts.widget').then(m => m.CoursesStatisticsShortcutsWidget),
        config: {}
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMpfCoursesFrontendManagementFeature_BaseFactory;
        return function MpfCoursesFrontendManagementFeature_Factory(__ngFactoryType__) {
          return (ɵMpfCoursesFrontendManagementFeature_BaseFactory || (ɵMpfCoursesFrontendManagementFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MpfCoursesFrontendManagementFeature)))(__ngFactoryType__ || MpfCoursesFrontendManagementFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MpfCoursesFrontendManagementFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'management/manager',
          redirectTo: 'management/courses'
        } // catch legacy paths
        ]), provideFeatureAddonRoutes([{
          useAddonSlot: 'management',
          path: 'courses',
          loadChildren: () => import('./courses-management.module').then(m => m.CoursesFrontendManagementModule)
        }])]
      });
    }
  };
  MpfCoursesFrontendManagementFeature = __decorate([ClassName("MpfCoursesFrontendManagementFeature")], MpfCoursesFrontendManagementFeature);
  return MpfCoursesFrontendManagementFeature;
})();
export { MpfCoursesFrontendManagementFeature };